import React from 'react';

function ArrowIcon({ className }) {
  return (
    <svg
      className={className}
      viewBox="0 0 512 512"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      width="16"
      height="16"
    >
      <polygon points="256,12.742 0,268.753 40.55,309.291 227.334,122.495 227.334,499.258 284.675,499.258 284.675,122.495 471.462,309.291 512,268.753" />
    </svg>
  );
}

export default ArrowIcon;
